// eslint-disable-next-line
/* eslint-disable */

import api from '@/utils/backend-api';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		items: {}
	},

	getters: {
		clubs(state) {
			return state.items;
		},
	},

	mutations: {
		setLoading(state, isLoading) {
			state.isLoading = isLoading
		},
		setItems(state, items) {
			state.items = items
		},
	},

	actions: {
		loadClubs(context) {
			context.commit('setLoading', true);

			api.postData('driver/club/count').then(items => {
				context.commit('setItems', items.data);
				context.commit('setLoading', false);
			}).catch(() => {
				context.commit('setLoading', false);
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/clubs.js